import { render, staticRenderFns } from "./AuthLayout.vue?vue&type=template&id=5471cd4c&scoped=true"
var script = {}
import style0 from "./AuthLayout.vue?vue&type=style&index=0&id=5471cd4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5471cd4c",
  null
  
)

export default component.exports